import { getContainerPrefix, normalizeContainerNumber } from './container-number';
/**
 * Carrier-Seed der großen Linien in den Nord-/Westhäfen.
 * Präfix-Listen zusammengeführt aus prefixlist.com (docs/research/carrier-prefixes.json) UND der
 * Arbeitsliste „container_praefixe_reedereien.xlsx" (Stand 19.06.2026; Quellen BIC-Register,
 * ShipsGo, A2Cargo). Wichtige Anmerkungen aus der Liste umgesetzt:
 *  - Ein Präfix ist ein ISO-6346/BIC Owner-/Operator-Code → identifiziert den registrierten Owner,
 *    nicht zwingend die aktuell befördernde Reederei. Bei Lease/gemischten Boxen Reederei erfragen.
 *  - COSCO & OOCL gehören zwar zusammen, werden hier aber als EIGENE Reedereien geführt (getrennte
 *    Tracking-Quellen). Hamburg Süd bleibt eigenständig (nicht unter Maersk), Sealand ebenso.
 *  - Mehrdeutige Codes (GLDU, FBIU, OCGU) werden NICHT fest zugeordnet → siehe LEASE_PREFIXES.
 * Erweiterbar.
 */
export const CARRIERS = [
    {
        code: 'MSCU',
        name: 'MSC — Mediterranean Shipping Company',
        prefixes: ['MADU', 'MEDU', 'MSCU', 'MSDU', 'MSMU', 'MSNU', 'MSRU'],
        trackingUrl: 'https://www.msc.com/track-a-shipment',
    },
    {
        code: 'MAEU',
        name: 'Maersk',
        prefixes: ['ACTU', 'AJCU', 'APMU', 'BSLU', 'CADU', 'CMBU', 'CSSU', 'DNLU', 'ENAU', 'FAAU', 'FRLU', 'GBEU', 'GBLU', 'GRIU', 'HASU', 'HDLU', 'KHJU', 'KHLU', 'KNLU', 'LOTU', 'MAEU', 'MALU', 'MCAU', 'MCHU', 'MCIU', 'MCPU', 'MCRU', 'MGBU', 'MHHU', 'MIEU', 'MMAU', 'MNBU', 'MPWU', 'MRKU', 'MRLU', 'MRSU', 'MSAU', 'MSFU', 'MSKU', 'MSVU', 'MSWU', 'MVIU', 'MWCU', 'MWMU', 'NDLU', 'NZSU', 'OCLU', 'PERU', 'POCU', 'PONU', 'RMLU', 'SAMU', 'SCMU', 'SEAU', 'TORU'],
        trackingUrl: 'https://www.maersk.com/tracking/',
    },
    {
        code: 'SUDU',
        name: 'Hamburg Süd',
        prefixes: ['SUDU'],
        trackingUrl: 'https://www.hamburgsud-line.com/liner/en/liner_services/ecommerce/track_trace/index.html',
    },
    {
        code: 'CMAU',
        name: 'CMA CGM',
        prefixes: ['AMCU', 'ANNU', 'APHU', 'APIU', 'APLU', 'APRU', 'APZU', 'CGHU', 'CGMU', 'CGTU', 'CMAU', 'CMDU', 'CMNU', 'CNCU', 'CXDU', 'CXRU', 'DVRU', 'ECMU', 'KLCU', 'MMCU', 'NEPU', 'NOLU', 'NOSU', 'NUSU', 'OPDU', 'OTAU', 'SMUU', 'SOFU', 'STMU'],
        trackingUrl: 'https://www.cma-cgm.com/ebusiness/tracking/search',
    },
    {
        code: 'HLCU',
        name: 'Hapag-Lloyd',
        prefixes: ['AZLU', 'CASU', 'CLGU', 'CMUU', 'CPSU', 'CSQU', 'DALU', 'DAYU', 'FANU', 'FMGU', 'HAMU', 'HLBU', 'HLCU', 'HLXU', 'HPLU', 'ITAU', 'IVLU', 'LNXU', 'LYKU', 'LYTU', 'NDSU', 'NIDU', 'PCRU', 'PLVU', 'PSBU', 'QIBU', 'QNNU', 'SIUU', 'TLEU', 'TMMU', 'UACU', 'UAEU', 'UASU', 'USCU'],
        trackingUrl: 'https://www.hapag-lloyd.com/en/online-business/track/track-by-container-solution.html',
    },
    {
        code: 'COSU',
        name: 'COSCO Shipping Lines',
        prefixes: ['BSDU', 'CBHU', 'CCLU', 'COSU', 'CSLU', 'CSNU'],
        trackingUrl: 'https://elines.coscoshipping.com/ebusiness/cargoTracking',
    },
    {
        code: 'OOLU',
        name: 'OOCL',
        prefixes: ['OOCU', 'OOLU'],
        trackingUrl: 'https://www.oocl.com/eng/ourservices/eservices/cargotracking/',
    },
    {
        code: 'EGLV',
        name: 'Evergreen Marine',
        prefixes: ['EGHU', 'EGLV', 'EGSU', 'EISU', 'EITU', 'EMCU', 'HMCU', 'TXGU', 'UGMU'],
        trackingUrl: 'https://www.evergreen-marine.com/',
    },
    {
        code: 'ONEY',
        name: 'Ocean Network Express (ONE)',
        prefixes: ['KKFU', 'KKLU', 'KKTU', 'MOAU', 'MOEU', 'MOFU', 'MOGU', 'MOLU', 'MORU', 'MOSU', 'MOTU', 'NYKU', 'NYNU', 'ONEU', 'ONPU', 'OPPU'],
        trackingUrl: 'https://ecomm.one-line.com/one-ecom/manage-shipment/cargo-tracking',
    },
    {
        code: 'YMLU',
        name: 'Yang Ming',
        prefixes: ['YMAU', 'YMLU', 'YMMU'],
        trackingUrl: 'https://www.yangming.com/en/esolution/cargo_tracking',
    },
    {
        code: 'HMMU',
        name: 'HMM (Hyundai Merchant Marine)',
        prefixes: ['HDMU', 'HMMU', 'KOCU', 'SZLU'],
        trackingUrl: 'https://www.hmm21.com/company/secured/Cs_cargoTrackingDetail.do',
    },
    {
        code: 'ZIMU',
        name: 'ZIM',
        prefixes: ['GSLU', 'JXLU', 'JZPU', 'ZCLU', 'ZCSU', 'ZHLU', 'ZIMU', 'ZMOU'],
        trackingUrl: 'https://www.zim.com/tools/track-a-shipment',
    },
    {
        code: 'WHLU',
        name: 'Wan Hai Lines',
        prefixes: ['TGCU', 'TPCU', 'WHAU', 'WHCU', 'WHLU', 'WHSU'],
        trackingUrl: 'https://www.wanhai.com/views/cargoTrack/CargoTracking.xhtml',
    },
    {
        code: 'PILU',
        name: 'Pacific International Lines (PIL)',
        prefixes: ['HPCU', 'PCIU', 'PIDU', 'PILU'],
        trackingUrl: 'https://www.pilship.com/en-our-services-track-and-trace/123.html',
    },
    {
        code: 'SEJJ',
        name: 'Sealand — A Maersk Company',
        prefixes: ['SLQU', 'WKSU'],
        trackingUrl: 'https://www.sealandmaersk.com/track-and-trace',
    },
    {
        code: 'MATU',
        name: 'Matson',
        prefixes: ['MATU'],
        trackingUrl: 'https://www.matson.com/shipment-tracking.html',
    },
    {
        code: 'ARKU',
        name: 'Arkas Line',
        prefixes: ['ARKU'],
        trackingUrl: 'https://www.arkasline.com/en',
    },
    {
        code: 'ACLU',
        name: 'Atlantic Container Line (ACL)',
        prefixes: ['ACLU'],
        trackingUrl: 'https://www.aclcargo.com/',
    },
    {
        code: 'AALU',
        name: 'Austral Asia Line (AAL)',
        prefixes: ['AALU'],
        trackingUrl: 'https://www.aalshipping.com/',
    },
    {
        code: 'SKLU',
        name: 'Sinokor Merchant Marine',
        prefixes: ['SKHU', 'SKLU', 'SKRU'],
        trackingUrl: 'https://www.sinokor.co.kr/',
    },
    {
        code: 'SNLU',
        name: 'Sinotrans Container Lines (Sinolines)',
        prefixes: ['SNBU', 'SNGU', 'SNHU'],
        trackingUrl: 'https://www.sinolines.com/',
    },
    {
        code: 'SITU',
        name: 'SITC Container Lines',
        prefixes: ['SITU'],
        trackingUrl: 'https://www.sitc.com/',
    },
];
/**
 * Mehrdeutige Präfixe: laut Registry sowohl einer großen Linie als auch einem
 * kleineren Owner zugeordnet. Auflösung erfolgt zur Linie, aber mit `ambiguous: true`,
 * damit das UI die Reederei bestätigen lassen kann.
 */
export const AMBIGUOUS_PREFIXES = new Set(['CASU', 'DVRU', 'KLCU', 'MALU', 'MEDU', 'WKSU']);
/**
 * Bekannte Vermietungs-/Lease-Präfixe sowie ausdrücklich als mehrdeutig markierte Codes
 * (GLDU/FBIU/OCGU laut container_praefixe_reedereien.xlsx — „nicht als reine Reederei-Zuordnung
 * nutzen"). Container ohne eindeutige Reederei: hier muss der User die Reederei vor der Prüfung
 * angeben.
 */
export const LEASE_PREFIXES = new Set(['BMOU', 'BSIU', 'CAIU', 'CAXU', 'DRYU', 'FBIU', 'FCIU', 'GATU', 'GESU', 'GLDU', 'MAGU', 'OCGU', 'SEGU', 'TCLU', 'TCNU', 'TGBU', 'TGHU', 'TLLU', 'TRHU', 'TRLU', 'UESU']);
// Schneller Präfix-Index.
const PREFIX_INDEX = (() => {
    const map = new Map();
    for (const c of CARRIERS)
        for (const p of c.prefixes)
            map.set(p, c);
    return map;
})();
/**
 * Ermittelt die Reederei zu einer Container-Nummer anhand des Präfix.
 * Siehe docs/PRD.md FR-L2..FR-L4.
 */
export function resolveCarrier(containerNumber) {
    const prefix = getContainerPrefix(normalizeContainerNumber(containerNumber));
    if (!prefix)
        return { status: 'unknown' };
    const carrier = PREFIX_INDEX.get(prefix);
    if (carrier)
        return { status: 'resolved', carrier, ambiguous: AMBIGUOUS_PREFIXES.has(prefix) };
    if (LEASE_PREFIXES.has(prefix))
        return { status: 'lease' };
    return { status: 'unknown' };
}
/**
 * Reederei-Aliase je Code: Terminals/Kunden geben die Reederei sehr unterschiedlich an — als
 * Kürzel („MAE", „COS", „ONE"), vollen Namen, ISO/SCAC oder Container-Präfix. Diese Liste sammelt
 * die bekannten Schreibweisen ZUSÄTZLICH zu `code` + `prefixes` (die automatisch mit indiziert
 * werden). Erweiterbar je neuem Terminal/Boxoperator-Wert.
 */
const CARRIER_ALIASES = {
    MSCU: ['MSC', 'MEDITERRANEAN SHIPPING COMPANY'],
    MAEU: ['MAE', 'MAERSK', 'MAERSK LINE', 'MSK', 'MAERSK A/S'],
    SUDU: ['SUD', 'HAMBURG SUD', 'HAMBURG SÜD', 'HSDG'],
    CMAU: ['CMA', 'CMA CGM', 'CMDU', 'CGM', 'CMA-CGM'],
    HLCU: ['HLC', 'HPL', 'HAPAG', 'HAPAG LLOYD', 'HAPAG-LLOYD'],
    COSU: ['COS', 'COSCO', 'COSCO SHIPPING', 'COSCON', 'COSHAN', 'CHINA COSCO'],
    OOLU: ['OOCL', 'ORIENT OVERSEAS'],
    EGLV: ['EVERGREEN', 'EMC', 'EVERGREEN MARINE', 'EVG'],
    ONEY: ['ONE', 'OCEAN NETWORK EXPRESS'],
    YMLU: ['YANG MING', 'YML'],
    HMMU: ['HMM', 'HYUNDAI', 'HYUNDAI MERCHANT MARINE'],
    ZIMU: ['ZIM'],
    WHLU: ['WAN HAI', 'WHL', 'WAN HAI LINES'],
    PILU: ['PIL', 'PACIFIC INTERNATIONAL LINES'],
    SEJJ: ['SEALAND', 'SEA-LAND', 'SEALAND MAERSK'],
    MATU: ['MATSON'],
    ARKU: ['ARKAS', 'ARKAS LINE'],
    ACLU: ['ACL', 'ATLANTIC CONTAINER LINE'],
    AALU: ['AAL', 'AAL SHIPPING', 'AUSTRAL ASIA LINE'],
    SKLU: ['SINOKOR', 'SINOKOR MERCHANT MARINE'],
    SNLU: ['SINOTRANS', 'SINOLINES', 'SINOTRANS CONTAINER LINES'],
    SITU: ['SITC', 'SITC CONTAINER LINES'],
};
/**
 * Reederei-Signalwörter für FREITEXT-Dokumente (B/L, Buchungsbestätigung, PDF-Import). Bewusst
 * KONSERVATIVER und eigenständig gepflegt statt aus `CARRIER_ALIASES` abgeleitet: in einem Fließtext
 * würden kurze Kürzel („ONE", „COS", „MAE") ständig falsch anschlagen. Hier stehen daher nur
 * Schreibweisen, die in einem Dokument praktisch nur von dieser Reederei stammen. Erweiterbar.
 */
const CARRIER_TEXT_SIGNALS = {
    MSCU: ['MSC', 'MEDITERRANEAN SHIPPING'],
    MAEU: ['MAERSK'],
    SUDU: ['HAMBURG SUED', 'HAMBURG SUD', 'HAMBURG SUD LINE'],
    CMAU: ['CMA CGM', 'CMA-CGM'],
    HLCU: ['HAPAG'],
    COSU: ['COSCO'],
    OOLU: ['OOCL', 'ORIENT OVERSEAS'],
    EGLV: ['EVERGREEN LINE', 'EVERGREEN MARINE', 'EVERGREEN SHIPPING'],
    ONEY: ['OCEAN NETWORK EXPRESS'],
    YMLU: ['YANG MING'],
    HMMU: ['HYUNDAI MERCHANT', 'HMM'],
    ZIMU: ['ZIM INTEGRATED', 'ZIM LINE'],
    WHLU: ['WAN HAI'],
    PILU: ['PACIFIC INTERNATIONAL LINES'],
    SEJJ: ['SEALAND', 'SEA-LAND'],
    MATU: ['MATSON'],
    ARKU: ['ARKAS'],
    ACLU: ['ATLANTIC CONTAINER LINE'],
    AALU: ['AAL SHIPPING', 'AUSTRAL ASIA LINE'],
    SKLU: ['SINOKOR'],
    SNLU: ['SINOTRANS', 'SINOLINES'],
    SITU: ['SITC'],
};
/** Umlaute/ß auflösen + UPPER — damit „Hamburg Süd" und „HAMBURG SUED" gleich behandelt werden. */
const foldText = (s) => (s ?? '')
    .toUpperCase()
    .replace(/Ä/g, 'AE')
    .replace(/Ö/g, 'OE')
    .replace(/Ü/g, 'UE')
    .replace(/ß/g, 'SS');
const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/**
 * Signalwort → Regex mit Wortgrenzen; zwischen den Wörtern sind bis zu drei Nicht-Wortzeichen
 * erlaubt (Zeilenumbruch, Bindestrich, mehrfache Leerzeichen aus dem PDF-Textlayer).
 */
const signalPattern = (signal) => {
    const words = foldText(signal).split(/[^A-Z0-9]+/).filter(Boolean);
    return new RegExp(`\\b${words.map(escapeRe).join('[^A-Z0-9]{0,3}')}\\b`, 'g');
};
const CARRIER_TEXT_PATTERNS = (() => {
    const list = [];
    for (const c of CARRIERS) {
        for (const s of CARRIER_TEXT_SIGNALS[c.code] ?? [])
            list.push({ re: signalPattern(s), carrier: c });
    }
    return list;
})();
/**
 * Ermittelt die Reederei aus dem FREITEXT eines Dokuments (PDF-Import: B/L, Buchungsbestätigung).
 * Es gewinnt die Reederei mit den meisten Treffern im Dokument — auf einem B/L steht der Name der
 * ausstellenden Linie typischerweise mehrfach (Kopf, Fußzeile, Bedingungen). `null` = kein sicherer
 * Treffer; die Reederei je Container wird dann weiter über das Präfix (resolveCarrier) bestimmt.
 */
export function findCarrierInText(raw) {
    const text = foldText(raw);
    if (!text.trim())
        return null;
    let best = null;
    let bestHits = 0;
    const hits = new Map();
    for (const { re, carrier } of CARRIER_TEXT_PATTERNS) {
        re.lastIndex = 0;
        const count = (text.match(re) ?? []).length;
        if (!count)
            continue;
        const total = (hits.get(carrier.code) ?? 0) + count;
        hits.set(carrier.code, total);
        if (total > bestHits) {
            bestHits = total;
            best = carrier;
        }
    }
    return best;
}
/** Normalisiert einen Alias/Boxoperator-Wert: UPPER, nur A–Z/0–9. */
const normalizeAlias = (s) => (s ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
// Exakt-Index über Code, Präfixe und Aliase (alle normalisiert).
const ALIAS_INDEX = (() => {
    const map = new Map();
    const add = (key, c) => {
        const k = normalizeAlias(key);
        if (k && !map.has(k))
            map.set(k, c);
    };
    for (const c of CARRIERS) {
        add(c.code, c);
        for (const p of c.prefixes)
            add(p, c);
        for (const a of CARRIER_ALIASES[c.code] ?? [])
            add(a, c);
    }
    return map;
})();
// Nur „wortartige" Aliase (≥4) für den Teilstring-Fallback (schmutzige Volltexte); längste zuerst.
const SUBSTRING_ALIASES = (() => {
    const list = [];
    for (const c of CARRIERS) {
        for (const a of CARRIER_ALIASES[c.code] ?? []) {
            const k = normalizeAlias(a);
            if (k.length >= 4)
                list.push([k, c]);
        }
    }
    return list.sort((a, b) => b[0].length - a[0].length);
})();
/**
 * Löst eine beliebige Reederei-Schreibweise eines Terminals/Kunden auf die kanonische Reederei auf
 * (Kürzel wie „MAE"/„COS"/„ONE", Code/SCAC, Owner-Präfix, voller Name). Exakt-Match zuerst, dann
 * Teilstring für schmutzige Volltexte (z. B. „COSHAN Co.Ltd. (COSCO)" → COSCO). `null` = unbekannt.
 * Damit wird das pro-Terminal unterschiedliche Boxoperator-Feld portalweit vereinheitlicht.
 */
export function resolveCarrierAlias(raw) {
    const norm = normalizeAlias(raw);
    if (!norm)
        return null;
    const exact = ALIAS_INDEX.get(norm);
    if (exact)
        return exact;
    for (const [alias, carrier] of SUBSTRING_ALIASES)
        if (norm.includes(alias))
            return carrier;
    return null;
}
//# sourceMappingURL=carriers.js.map